__turbopack_context__.v({
  "bar": "AIStickyBar-module__9j_PLq__bar",
  "cta": "AIStickyBar-module__9j_PLq__cta",
  "icon": "AIStickyBar-module__9j_PLq__icon",
  "left": "AIStickyBar-module__9j_PLq__left",
  "text": "AIStickyBar-module__9j_PLq__text",
  "wrapper": "AIStickyBar-module__9j_PLq__wrapper",
});
